module.exports = __webpack_public_path__ + "img/browse-folder.d6ab725a.png";